import { useState, useEffect, useCallback } from "react";
import toastError from "../../errors/toastError";
import { format, sub } from 'date-fns'
import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  users,
  pageNumber,
  status,
  date,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  whatsappIds,
  statusFilter,
  forceSearch,
  userFilter,
  sortTickets,
  searchOnMessages,
  empresa,
  dateStart,
  dateEnd
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        if (userFilter === undefined || userFilter === null) {
          try {            
            const { data } = await api.get("/tickets", {
              params: {
                searchParam,
                pageNumber,
                tags,
                users,
                status,
                date,
                updatedAt,
                showAll,
                queueIds,
                withUnreadMessages,
                whatsapps: whatsappIds,
                statusFilter,
                sortTickets,
                searchOnMessages,
                empresa,
                dateStart,
                dateEnd
              },
            });
            
            let tickets = [];
            
            tickets = data.tickets;
          
            setTickets(tickets);
            setHasMore(data.hasMore);
            setCount(data.count)
            setLoading(false);
          } catch (err) {
            setLoading(false);
            toastError(err);
          }
        } else {
          try {
            // console.log("ENTROU AQUI DASH")
            // console.log(status,
            //   showAll,
            //   queueIds,
            //   format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd'),
            //   format(new Date(), 'yyyy-MM-dd'),
            //   userFilter)

            const {data} = await api.get("/dashboard/moments", {
              params: {
                status,
                showAll,
                queueIds,
                dateStart: format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd'),
                dateEnd: format(new Date(), 'yyyy-MM-dd'),
                userId: userFilter
              }
            })

            // console.log(data)
            let tickets = [];
            tickets = data.filter(item => item.userId == userFilter);            

            setTickets(tickets);
            setHasMore(null);
            setLoading(false);
          } catch (err) {
            setLoading(false);
            toastError(err);
          }
        }
      };
    fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    tags,
    users,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    whatsappIds,
    statusFilter,
    forceSearch,
    sortTickets,
    searchOnMessages,
    empresa,
    dateStart,
    dateEnd
  ]);

  // Função para recarregar os dados sem mudar os parâmetros
  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/tickets", {
        params: {
          searchParam,
          tags,
          users,
          pageNumber,
          status,
          date,
          updatedAt,
          showAll,
          queueIds,
          withUnreadMessages,
          whatsapps: whatsappIds,
          statusFilter,
          userFilter,
          sortTickets,
          searchOnMessages,
          empresa,
          dateStart,
          dateEnd
        }
      });
      setCount(data.count);
      return data;
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [
    searchParam,
    tags,
    users,
    pageNumber,
    status,
    date,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    whatsappIds,
    statusFilter,
    userFilter,
    sortTickets,
    searchOnMessages,
    empresa,
    dateStart,
    dateEnd
  ]);

  return { tickets, loading, hasMore, count, refetch };
};

export default useTickets;
